import * as React from 'react'

type ImageProps = Omit<React.ImgHTMLAttributes<HTMLImageElement>, 'src'> & {
  src: string
  alt: string
  fill?: boolean
  sizes?: string
  priority?: boolean
}

const Image = React.forwardRef<HTMLImageElement, ImageProps>(
  ({ fill, priority: _priority, style, ...props }, ref) => {
    const fillStyles: React.CSSProperties | undefined = fill
      ? { position: 'absolute', inset: 0, width: '100%', height: '100%', ...style }
      : style

    return <img ref={ref} style={fillStyles} {...props} />
  },
)

Image.displayName = 'Image'

export default Image
